import { type Certificate } from 'common/certificates/certificates.types'

import { Role, type GroupUser, type UserGroup, type UserStatus, type User } from '../utils/types'

export interface UserDB {
  id: string
  name: {
    first: string
    last: string
  }
  email: string
  role: string
  photo?: {
    url: string
    expiresIn: number
  }
  companyName?: string
  status: UserStatus
  nickname?: string
  certificates?: Certificate[]
  isVendor?: boolean
  aprEmail?: string
  companyId?: string
}

const getRole = (role: string): Role => {
  switch (role) {
    case 'admin': {
      return Role.admin
    }
    case 'consultant': {
      return Role.consultant
    }
    case 'stakeholder': {
      return Role.stakeholder
    }
    case 'vendor': {
      return Role.vendor
    }
    case 'company': {
      return Role.company
    }
  }
  return Role.stakeholder
}

export const transformUsersData = (
  usersDB: UserDB[],
  count: number,
  roles: Role[],
): { users: User[]; count: number; roles: Role[] } => {
  return {
    users: usersDB.map((user: UserDB) => {
      return {
        id: user.id,
        photo: user.photo?.url,
        name: user.name,
        role: getRole(user.role),
        status: user.status,
        email: user.email,
        nickname: user.nickname,
        certificates: user?.certificates,
        companyName: user?.companyName,
        isVendor: user.isVendor,
        aprEmail: user.aprEmail,
        companyId: user.companyId,
      }
    }),
    count,
    roles,
  }
}

export const transformGroupUsersData = (
  groupUsers: GroupUser[],
  count: number,
): { groupUsers: GroupUser[]; count: number } => {
  return {
    groupUsers: groupUsers.map((user: GroupUser) => {
      return {
        id: user.id,
        photo: user?.photo,
        role: Role.stakeholder,
        status: user.status,
        email: user.email,
        name: user.name,
        expiresIn: user.expiresIn,
      }
    }),
    count,
  }
}

export interface UserGroupDB {
  id: string
  name: string
  email?: string
  photo?: {
    url: string
    expiresIn: number
  }
  status: UserStatus
  slug: string
  role: Role
  certificates?: Certificate[]
}

export const transformUserGroupsData = (
  userGroupsDB: UserGroupDB[],
  count: number,
): { userGroups: UserGroup[]; count: number } => {
  return {
    userGroups: userGroupsDB.map((user: UserGroupDB) => {
      return {
        ...user,
        nickname: user.slug,
        role: Role.stakeholder,
      }
    }),
    count,
  }
}
